require("!!/Users/Shared/PLAYLANE/buildAgent/work/52a9d7f6ba866ad7/frontend/node_modules/script-loader/addScript.js")(require("!!/Users/Shared/PLAYLANE/buildAgent/work/52a9d7f6ba866ad7/frontend/node_modules/raw-loader/index.js!/Users/Shared/PLAYLANE/buildAgent/work/52a9d7f6ba866ad7/frontend/node_modules/babel-loader/lib/index.js!/Users/Shared/PLAYLANE/buildAgent/work/52a9d7f6ba866ad7/frontend/node_modules/eslint-loader/index.js!/Users/Shared/PLAYLANE/buildAgent/work/52a9d7f6ba866ad7/frontend/app/libs/Modernizr/modernizr-custom.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader?Modernizr!./app/libs/Modernizr/modernizr-custom.js
// module id = 862
// module chunks = 1